import Modal from "components/common/controls/modal/Modal";
import { EditorActionButtonProp } from "./EditorActionFooter";

interface Props {
  title?: string;
  content?: string;
  width?: string;
  contentComponent?: any;
  onCancel?: () => void;
  cancelButtonText?: string;
  confirmButtonText?: string;
  onConfirm?: () => void;
}

export default function ConfirmationDialog(props: Props) {
  const {
    title,
    content,
    contentComponent: ConentComponent,
    width,
    onCancel,
    cancelButtonText,
    onConfirm,
    confirmButtonText,
    ...rest
  } = props;

  const defaultActionProps: EditorActionButtonProp = {
    applyButtonCaption: confirmButtonText,
    cancelButtonCaption: cancelButtonText,
    onApply: onConfirm,
    onCancel: onCancel,
  };

  return (
    <Modal
      title={title}
      visible={true}
      width={width || "400"}
      height="auto"
      {...rest}
      defaultActionProp={defaultActionProps}
    >
      {ConentComponent ? <ConentComponent /> : content ?? <></>}
    </Modal>
  );
}
